import React from 'react';
import styled from 'styled-components';
import { Table } from 'react-bootstrap';
import { Match } from '../../models/interfaces/Match';
import { parseTeamColor } from '../../helpers/parseTeamColor';
import { MatchViewTextComponents } from '../../models/interfaces/ViewDescriptions/MatchViewDescription';

interface Props {
    match: Match;
    summaries: {
        title: string;
        lightCapTextComponents: MatchViewTextComponents;
        darkCapTextComponents: MatchViewTextComponents;
    }[];
    compact?: boolean;
}

const LightCapHeader = styled.th`
    text-align: right;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-shadow: inset 0 -0.3rem 0 0 ${({ color }) => color};
`;

const DarkCapHeader = styled.th`
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-shadow: inset 0 -0.3rem 0 0 ${({ color }) => color};
`;

const LightCapStatCell = styled.td`
    text-align: right;
    width: 40%;
`;
const StatCell = styled.td`
    text-align: center;
    width: 20%;
`;

const DarkCapStatCell = styled.td`
    width: 40%;
`;

export default function TeamMatchSummary({ match, summaries, compact = false }: Props) {
    return (
        <Table striped bordered className="shadow-sm" size={compact ? 'sm' : undefined}>
            <thead>
                <tr>
                    <LightCapHeader color={parseTeamColor(match.lightCapTeam.color)}>
                        {match.lightCapTeam.name}
                    </LightCapHeader>
                    <td />
                    <DarkCapHeader color={parseTeamColor(match.darkCapTeam.color)}>
                        {match.darkCapTeam.name}
                    </DarkCapHeader>
                </tr>
            </thead>
            <tbody>
                {summaries.map((summary) => {
                    return (
                        <tr key={summary.title}>
                            <LightCapStatCell>{summary.lightCapTextComponents.title}</LightCapStatCell>
                            <StatCell>{summary.title}</StatCell>
                            <DarkCapStatCell>{summary.darkCapTextComponents.title}</DarkCapStatCell>
                        </tr>
                    );
                })}
            </tbody>
        </Table>
    );
}
